<div class="video-container d-flex justify-content-center align-items-center h-200">
  <br />
  <mat-spinner *ngIf=" !cameraLoaded"></mat-spinner>
</div>
<div class="video-container d-flex justify-content-center align-items-center">

  <video [hidden]="isCaptured" #video id="video" [width]="WIDTH" [height]="HEIGHT" autoplay></video>
  <canvas [hidden]="!isCaptured" #canvas id="canvas" [width]="WIDTH" [height]="HEIGHT"></canvas>
</div>
<br />
<div class="snap-container">
  <button mat-raised-button color="primary" *ngIf="!isCaptured" (click)="capture()">
    Snap Photo
  </button>
  <button mat-raised-button color="primary" *ngIf="isCaptured" (click)="retake()">
    Retake
  </button>
</div>
